import { Route, Routes } from 'react-router';

import { Profile } from './scenes/Profile/Profile';
import { Search } from './scenes/Search/Search';

export const ContentPage = () => (
  <Routes>
    <Route path="/:language?/profiles/:slug" element={<Profile />} />
    <Route path="/:language?/profiles/search" element={<Search />} />
    <Route path="/:language?" element={<Search />} />
  </Routes>
);
